import * as React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  Box,
  Container,
  CssBaseline,
  Grid,
  List,
  ListItem,
  Divider,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
  Button,
  Skeleton,
  Modal,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
} from "@mui/material";
import avisosService from "../avisosService";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
const defaultTheme = createTheme();

export default function UserViewAvisos() {
  const {
    getAvisos,
    deleteAviso,
    getFuncionarios,
    postAviso,
    getAlunos,
    getMensagensEnviadas,
  } = avisosService();
  const [avisos, setAvisos] = useState([]);
  const [mensagensEnviadas, setMensagensEnviadas] = useState([]);
  const [updateFlag, setUpdateFlag] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [funcionarios, setFuncionarios] = useState([]);
  const [alunos, setAlunos] = useState([]);
  const [destinatariosAlunos, setDestinatariosAlunos] = useState([]);
  const [destinatariosFuncionarios, setDestinatariosFuncionarios] = useState(
    []
  );

  const [message, setMessage] = useState();
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const userData = useSelector((state) => state.userData);
  const { uuid } = useParams();

  const [openModal, setOpenModal] = useState(false);

  const handleModal = () => {
    setOpenModal(!openModal);
  };

  useEffect(() => {
    async function getData() {
      try {
        const response = await getAvisos(uuid);
        setAvisos(response.data);
        const responseFuncionarios = await getFuncionarios();
        setFuncionarios(responseFuncionarios.data);
        const responseAlunos = await getAlunos();
        setAlunos(responseAlunos.data);
        const responseMensagensEnviadas = await getMensagensEnviadas();
        setMensagensEnviadas(responseMensagensEnviadas.data);
        setIsLoading(false);
      } catch (error) {
        if (error.response) {
          console.log(error.response.data.message);
        } else {
          console.error(error.message);
        }
      }
    }
    getData();
  }, [updateFlag]);

  const removeAviso = async (uuid) => {
    try {
      await deleteAviso(uuid);
      toast.success("Mensagem removida com sucesso!");
      setUpdateFlag(!updateFlag);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
    }
  };

  const submitMessage = async () => {
    const form = {
      descricao: message,
      // Usar o estado correto com base no tipo de usuário
      destinatarios: userData.funcionario
        ? destinatariosAlunos
        : destinatariosFuncionarios,
      fk_uuid_remetente: uuid,
    };

    try {
      await postAviso(form);
      toast.success("Mensagem enviada com sucesso!");
      handleModal();
      setMessage("");
      // Limpar o estado correto após o envio
      userData.funcionario
        ? setDestinatariosAlunos([])
        : setDestinatariosFuncionarios([]);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
    }
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "40px",
    borderRadius: "20px",
  };

  // Funções de remoção de chip para cada tipo de usuário
  const handleRemoveAluno = (uuidToRemove) => {
    setDestinatariosAlunos((prev) =>
      prev.filter((uuid) => uuid !== uuidToRemove)
    );
  };
  const handleRemoveFuncionario = (uuidToRemove) => {
    setDestinatariosFuncionarios((prev) =>
      prev.filter((uuid) => uuid !== uuidToRemove)
    );
  };

  // Funções de manipulação separadas para cada tipo de Select
  const handleAlunosSelecionados = (event) => {
    const { value } = event.target;
    if (value.includes("todos")) {
      setDestinatariosAlunos(alunos.map((aluno) => aluno.uuid));
    } else {
      setDestinatariosAlunos(value);
    }
  };
  const handleFuncionariosSelecionados = (event) => {
    const { value } = event.target;
    setDestinatariosFuncionarios(value);
  };

  const handleMessageChange = (event) => {
    setMessage(event.target.value);
    setButtonDisabled(false);
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container maxWidth="xl">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Grid container>
            <Grid item xs={12}>
              <Button variant="contained" onClick={handleModal}>
                Enviar mensagem
              </Button>
            </Grid>
            <List
              sx={{
                width: "100%",
                bgcolor: "background.paper",
              }}
            >
              {isLoading ? (
                <div style={{ display: "flex", gap: "8px" }}>
                  <Skeleton variant="circular" width={40} height={40} />
                  <Skeleton variant="text" width={"100%"} />
                </div>
              ) : avisos.length > 0 ? (
                avisos.map((aviso) => {
                  return (
                    <div key={aviso.uuid}>
                      <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>
                        Mensagens Recebidas
                      </Typography>
                      <ListItem
                        alignItems="flex-start"
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <ListItemAvatar>
                          <Avatar>
                            {aviso.nome_remetente.substring(0, 2)}
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography
                                variant="body1"
                                p={1}
                                sx={{ fontWeight: 700 }}
                              >
                                {aviso.nome_remetente}
                              </Typography>
                            </div>
                          }
                          secondary={
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography variant="body1" p={1}>
                                {aviso.descricao}
                              </Typography>

                              <Button
                                onClick={() => {
                                  removeAviso(aviso.uuid);
                                }}
                                color="error"
                              >
                                Excluir
                              </Button>
                            </div>
                          }
                        />
                      </ListItem>
                      <Divider variant="inset" component="li" />
                    </div>
                  );
                })
              ) : (
                <Typography
                  variant="h6"
                  sx={{
                    color: "#212B2F",
                    fontWeight: "700",
                    fontSize: "1.125rem",
                    lineHeight: "1.5",
                    textAlign: "center",
                  }}
                >
                  Nenhuma mensagem recebida disponível
                </Typography>
              )}
              {userData.funcionario && (
                <Grid
                  item
                  xs={12}
                  sx={{ mt: 4, backgroundColor: "#f5f5f5", p: 2 }}
                >
                  <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>
                    Mensagens Enviadas
                  </Typography>
                  <List
                    sx={{
                      width: "100%",
                      bgcolor: "background.paper",
                    }}
                  >
                    {mensagensEnviadas.length > 0 ? (
                      mensagensEnviadas.map((mensagem) => (
                        <div key={mensagem.uuid}>
                          <ListItem
                            alignItems="flex-start"
                            sx={{ display: "flex", alignItems: "center" }}
                          >
                            <ListItemText
                              primary={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Typography
                                    variant="body1"
                                    p={1}
                                    sx={{ fontWeight: 700 }}
                                  >
                                    {/* Exibindo o destinatário ou 'Múltiplos' */}
                                    Destinatário:{" "}
                                    {mensagem.destinatarios.length > 1
                                      ? "Múltiplos"
                                      : alunos.find(
                                          (aluno) =>
                                            aluno.uuid ===
                                            mensagem.destinatarios[0]
                                        )?.nome || "N/A"}
                                  </Typography>
                                </div>
                              }
                              secondary={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Typography variant="body1" p={1}>
                                    {mensagem.descricao}
                                  </Typography>
                                  <Button
                                    onClick={() => removeAviso(mensagem.uuid)}
                                    color="error"
                                  >
                                    Excluir
                                  </Button>
                                </div>
                              }
                            />
                          </ListItem>
                          <Divider variant="inset" component="li" />
                        </div>
                      ))
                    ) : (
                      <Typography
                        variant="body1"
                        sx={{
                          textAlign: "center",
                          mt: 2,
                          color: "text.secondary",
                        }}
                      >
                        Nenhuma mensagem enviada disponível
                      </Typography>
                    )}
                  </List>
                </Grid>
              )}
            </List>
          </Grid>
        </Box>
      </Container>
      <Modal open={openModal} onClose={handleModal}>
        <Box sx={style}>
          <Container>
            <Grid container>
              <Grid
                item
                xs={12}
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {/* Lógica para mostrar os chips com base no tipo de usuário */}
                <Box
                  sx={{
                    width: "100%",
                    mb: 1,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px",
                  }}
                >
                  {userData.funcionario
                    ? alunos
                        .filter((aluno) =>
                          destinatariosAlunos.includes(aluno.uuid)
                        )
                        .map((aluno) => (
                          <Chip
                            key={aluno.uuid}
                            label={aluno.nome}
                            onDelete={() => handleRemoveAluno(aluno.uuid)}
                          />
                        ))
                    : funcionarios
                        .filter((func) =>
                          destinatariosFuncionarios.includes(func.uuid)
                        )
                        .map((func) => (
                          <Chip
                            key={func.uuid}
                            label={func.nome}
                            onDelete={() => handleRemoveFuncionario(func.uuid)}
                          />
                        ))}
                </Box>
                {/* Fim da exibição dos chips */}

                {/* Select condicional para funcionário */}
                {userData.funcionario && (
                  <FormControl fullWidth>
                    <InputLabel id="alunos-select-label">
                      Selecione um aluno
                    </InputLabel>
                    <Select
                      labelId="alunos-select-label"
                      label="Selecione um aluno"
                      id="alunos-select"
                      multiple
                      value={destinatariosAlunos}
                      onChange={handleAlunosSelecionados}
                      renderValue={() => (
                        <Box
                          sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                        ></Box>
                      )}
                    >
                      <MenuItem key="todos" value="todos">
                        Todos os Alunos
                      </MenuItem>
                      {alunos.map((aluno) => (
                        <MenuItem value={aluno.uuid} key={aluno.uuid}>
                          {aluno.nome}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}

                {/* Select condicional para aluno */}
                {!userData.funcionario && (
                  <FormControl fullWidth>
                    <InputLabel id="funcionarios-select-label">
                      Selecione um professor
                    </InputLabel>
                    <Select
                      labelId="funcionarios-select-label"
                      label="Selecione um professor"
                      id="funcionarios-select"
                      multiple
                      value={destinatariosFuncionarios}
                      onChange={handleFuncionariosSelecionados}
                      renderValue={() => (
                        <Box
                          sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                        ></Box>
                      )}
                    >
                      {funcionarios.map((func) => (
                        <MenuItem value={func.uuid} key={func.uuid}>
                          {func.nome}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  width: "100%",
                  mt: 3,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <TextField
                  fullWidth
                  multiline
                  value={message}
                  onChange={handleMessageChange}
                />
                {!buttonDisabled && (
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={submitMessage}
                      sx={{ mt: 2 }}
                    >
                      Enviar
                    </Button>
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Button onClick={handleModal} sx={{ mt: 2 }}>
                    Voltar
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Modal>
    </ThemeProvider>
  );
}
